import { Bars4Icon, DocumentDuplicateIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import {
  deleteApplicationEmailTemplate,
  duplicateApplicationEmailTemplate,
  enableApplicationEmailTemplate,
  getApplicationEmailTemplate,
  submitApplicationEmailTemplate,
} from 'services'
import { svgLoading } from 'stories/assets'
import { Button, Toggle } from 'stories/components'
import { Tooltip } from 'stories/components/Tooltip/Tooltip'
import { confirm, prompt } from 'utils'

export const ApplicationEmailTemplate = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<Array<any>>([])

  useEffect(() => {
    refresh()
  }, [])

  const refresh = () => {
    setIsLoading(true)
    getApplicationEmailTemplate()
      .then(({ data }) => {
        setData(data)
      })
      .finally(() => setIsLoading(false))
  }

  const onAdd = async (id: number, value: string) => {
    const res = await prompt(`${id ? 'Edit' : 'Add New'} Template`, { value })
    if (!res) return
    await submitApplicationEmailTemplate(id, { name: res })
    refresh()
  }

  const onEdit = (id: number) => {
    window.open(`/condition_template/applicationEmailTemplate/${id}`)
  }

  const onTrash = async (id: number) => {
    const result = await confirm('Do you want to remove this template?')
    if (!result) return

    setIsLoading(true)
    deleteApplicationEmailTemplate(id)
      .then(refresh)
      .catch(() => setIsLoading(false))
  }

  const onDuplicate = async (id: number) => {
    const result = await confirm('Are you sure you want to duplciate this email template?')
    if (!result) return
    await duplicateApplicationEmailTemplate(id)
    refresh()
  }

  const onEnable = async (id: number) => {
    setIsLoading(true)
    const res = await enableApplicationEmailTemplate(id)
    if (res.success) {
      const temp = cloneDeep(data)
      temp.map((item) => {
        if (item.id === id) {
          item.enabled = !item.enabled
        } else item.enabled = false
      })
      setData(temp)
    }
    setIsLoading(false)
  }

  return (
    <div className="relative">
      <h2 className="text-2xl font-bold flex items-center mb-3">
        Loan Application Email Templates
        {isLoading && (
          <span className="ml-3">
            <img src={svgLoading} className="inline w-6 h-6 text-white animate-spin" />
          </span>
        )}
      </h2>
      <div className="flex flex-wrap justify-end mb-3">
        <div className="w-32">
          <Button full onClick={() => onAdd(0, '')}>
            Add
          </Button>
        </div>
      </div>

      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-900 dark:text-gray-400 pl-6">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-3 py-3">
                No
              </th>
              <th scope="col" className="py-3 px-3">
                Name
              </th>
              <th scope="col" className="py-3 px-3">
                Enabled
              </th>
              <th scope="col" className="px-3">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="">
            {data.map((item: any, index) => {
              return (
                <tr className={`border-b ${index % 2 ? 'bg-slate-50' : 'bg-white'}`} key={`${index}`}>
                  <td scope="row" className="px-3 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="px-3">{item.name}</td>
                  <td className="px-3">
                    <Toggle
                      id={`enabled-${item.id}`}
                      title=""
                      value={item.enabled}
                      onChange={() => onEnable(item.id)}
                    />
                  </td>
                  <td className="px-3">
                    <span className="flex">
                      <Tooltip message="Edit Name">
                        <span
                          className="text-shade-blue p-1 hover-shadow1 cursor-pointer"
                          onClick={() => onAdd(item.id, item.name)}
                        >
                          <PencilSquareIcon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                      <Tooltip message="Edit Email">
                        <span
                          className="text-shade-blue  p-1 hover-shadow1 cursor-pointer"
                          onClick={() => onEdit(item.id)}
                        >
                          <Bars4Icon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                      <Tooltip message="Duplicate">
                        <span
                          className="text-shade-blue  p-1 hover-shadow1 cursor-pointer"
                          onClick={() => onDuplicate(item.id)}
                        >
                          <DocumentDuplicateIcon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                      <Tooltip message="Delete">
                        <span
                          className="text-red-800 p-1 hover-shadow1 cursor-pointer"
                          onClick={() => onTrash(item.id)}
                        >
                          <TrashIcon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                    </span>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
